module.exports = __webpack_public_path__ + "media/theme/border-2-c3a1dfe4.png";